import styled, { css } from "styled-components";
import { theme } from "../../../constants/StyledComponents";
import { FileUploaderSizeEnum } from "../../../types/AppTypes";

const uploadedStyles = css`
  background-color: ${theme.colors.grey_7};

  & > div {
    grid-template-columns: 1fr minmax(60px, min-content);
  }
`;

const notUploadedStyles = css`
  border: 1px dashed ${theme.colors.purple};
  background-color: ${theme.colors.white};
`;

const UploadFileContainer = styled.div<{ $selectedFile: boolean }>`
  width: auto;
  max-width: min-content;
  min-width: -webkit-fill-available;
  padding: 20px;
  border-radius: 12px;

  ${(props) => (props.$selectedFile ? uploadedStyles : notUploadedStyles)}
`;

type UploadFileBodyProps = {
  $size?: FileUploaderSizeEnum;
  $isDragOver?: boolean;
};

const sizes = (size = FileUploaderSizeEnum.REGULAR) =>
  ({
    regular: css`
      flex-direction: row;
    `,
    large: css`
      flex-direction: column;
      & > img {
        width: 140px;
      }
      & div {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    `,
  })[size];

const UploadFileBody = styled.div<UploadFileBodyProps>`
  display: grid;
  ${({ $size }) => sizes($size)};
  grid-template-columns: min-content 1fr;
  gap: 20px;
  align-items: center;
  width: 100%;

  & .container-details-file {
    display: grid;
    grid-template-columns: min-content 1fr;
    align-items: center;
    gap: 20px;
    width: 100%;
  }

  & .container-icon {
    display: grid;
    grid-template-columns: min-content min-content;
  }

  & .upload-label {
    padding: 0 5px;
  }
`;

export { UploadFileContainer, UploadFileBody };
